import styled from '@emotion/styled'
import { KleanadsScopeConfig } from '@pubstack/common/src/kleanadsScopeConfig'
import { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { useKleanadsScopeConfig, useUpdateKleanadsPocOverrides } from '~/api/admin/kleanads-config.api'
import { Link } from '~/components/Link'
import { Message } from '~/components/Message'
import { Skeleton } from '~/components/Skeleton'
import { JSONEditor } from '../PureJSONEditor'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const AdminScopePocOverridesConfig: FunctionComponent = () => {
  const { scopeId } = useParams()

  const { data: scopeConfig, isLoading, isFetching } = useKleanadsScopeConfig(scopeId ?? '')
  const { mutateAsync: updatePocOverrides } = useUpdateKleanadsPocOverrides(scopeId ?? '', {
    successToast: 'The POC overrides have been updated. Check #kleanads-ops for the changes.',
    errorToast: 'An error has occurred, please retry later.',
  })

  const onPocOverridesUpdate = async (pocOverrides: KleanadsScopeConfig['pocOverrides']) => {
    await updatePocOverrides(pocOverrides)
  }

  const isLoadingState = isLoading || isFetching
  const isScopeConfigMissing = !scopeConfig

  return (
    <Wrapper>
      <Message
        status={'warning'}
        title={'Warning'}
        description={
          <Wrapper>
            <span>Poc overrides edition, please be careful.</span>
            <span>
              Be wary that NO VALIDATION is done on{' '}
              <Link
                label={'specific POC OVERRIDES FORMAT'}
                href={'https://www.notion.so/Trials-and-Onboarding-Board-4bbe1c95898f44928d6a8f79a5a5efd5#49535502adb84cea829a134cba398a08'}
                trackingLabel={'adm-admin-scopes-detail-pocoverrides-doc-navigate'}
              />
              , only on JSON format.
            </span>
            <span>Double check everything you are doing.</span>
          </Wrapper>
        }
      />
      {isLoadingState ? (
        <Skeleton bigger />
      ) : isScopeConfigMissing ? (
        <Message status={'error'} title={'Error'} description={'Scope config is missing, please select a scope with a proper scope config.'} />
      ) : (
        <JSONEditor data={scopeConfig?.pocOverrides ?? {}} onValidate={onPocOverridesUpdate} statusUpdate={() => {}} />
      )}
    </Wrapper>
  )
}
